import { RecurrenceValues } from 'src/Hooks/Forms/UseCreateEventForm/useCreateEventForm.types';
import parseIntSafe from 'src/Services/Shared/parseIntSafe';

export const handleWeeklyRecurrence = (values: RecurrenceValues) => {
  if (values.byWeekDays.length > 0) {
    return { byWeekDay: values.byWeekDays.map(parseIntSafe) };
  }

  return {};
};
